import { Alert } from '@mint-lib/tw-components/patterns';

import { SnackbarContentProps } from './types.js';

type colors = 'success' | 'info' | 'warning' | 'error';

export function Snackbar({ ...props }: SnackbarContentProps) {
  return (
    <Alert
      {...props}
      title={props.title}
      description={props.subTitle as string}
      variant={props.textLayout}
      severity={props.variant as colors}
      className={'w-100'}
    >
      {props.actions}
    </Alert>
  );
}
